<template>
  <!-- <Dialog v-model:visible="showDialog" :modal="true" :header="$t('subgroup.title')"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '40vw' }"> -->
  <Dialog
    :modal="true"
    v-model:visible="showDialog"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    :header="
      model ? $t('accountSubHead.Edittitle') : $t('accountSubHead.title')
    "
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="6">
          <div class="field">
            <TextField
              :required-icon="true"
              id="code"
              name="code"
              :label="$t('accountSubHead.code')"
              :rules="{ required: true }"
              v-model="Subgroupform.Code"
              type="text"
              placeholder=" "
              disabled
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              :required-icon="true"
              id="Account Sub Head Name"
              name="Account Sub Head Name"
              :label="$t('accountSubHead.name')"
              :rules="{ required: true }"
              v-model="Subgroupform.Name"
              type="text"
              placeholder=" "
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <CustomDropdown
            :required-icon="true"
            :label="$t('accountSubHead.AccountsHead')"
            v-model="Subgroupform.AccheadId"
            :rules="{ required: true }"
            :name="$t('accountSubHead.AccountsHead')"
            :id="$t('accountSubHead.AccountsHead')"
            :items="AccHeadOptions"
            @update:model-value="handleAccSubChange"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <CustomDropdown
            :required-icon="true"
            :label="$t('accountHead.Nature')"
            v-model="Subgroupform.NatureofGroupName"
            :rules="{ required: true }"
            :name="$t('accountHead.Nature')"
            :id="$t('accountHead.Nature')"
            :items="natureOptions"
            @update:model-value=""
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <CustomDropdown
            :required-icon="true"
            :label="$t('accountSubHead.Classification')"
            v-model="Subgroupform.ClassificationType"
            :rules="{ required: true }"
            :name="$t('accountSubHead.Classification')"
            :id="$t('accountSubHead.Classification')"
            :items="ClassificationOptions"
            @update:model-value=""
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              :required-icon="false"
              id="Description"
              name="Description"
              :label="$t('accountSubHead.Description')"
              :rules="{ required: false }"
              v-model="Subgroupform.Description"
              type="text"
              placeholder=" "
            />
          </div>
        </b-col>
      </b-row>
      <Footer
        @cancel="(showDialog = false), IsClear()"
        :cancelhide="false"
        :label="label"
        :loading="Saveloading"
      />
    </b-form>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <EditConfirmation
    :Editmodel="Editmodel"
    @yes="IsEdit()"
    @no="Editmodel = false"
    :content="$t('confirmation.editcontent')"
  />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import AccountSubHeadService from "../../../../../../modules/Inventory/Service/AccountSubHeadService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import moment from "moment";
import AccountHeadService from "../../../../../../modules/Inventory/Service/AccountHeadService";
import { number } from "yup";
export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    AlreadyExist,
    CreateSuccessully,
    UpdatedSuccessfully,
    EditConfirmation,
    CustomDropdown,

    Footer,
    TextField,
  },
  setup(props, { emit }) {
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    // let Entitydata = ref();
    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let AccHeadOptions = ref({});
    let natureOptions = ref({});

    const ClassificationOptions = ref([
      { name: "General  Ledger", value: 1 },
      { name: "Bank", value: 2 },
      { name: "Tax Rate", value: 3 },
      { name: "Product / Service", value: 4 },
      { name: "Contact", value: 5 },
      { name: "Sales Accounts", value: 6 },
      { name: "Purchase Accounts", value: 7 },
      { name: "Cash", value: 8 },
      { name: "Bank/OD", value: 9 },
    ]);

    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    let Saveloading = ref(false);
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
    function IsCreate() {
      showDialog.value = true;
      GetCode();
    }
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);

      LoadAccountHeadList();
      LoadNatureList();
    });

    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        IsSubmit();
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      }
      // else if (event.altKey && event.key == 'n') {
      // showDialog.value = true;
      // }
      else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
      // else if (event.key == 'e') {
      // IsEdit()
      // }
      // else if (event.key == 'Escape') {

      // IsClear()
      // }
    }
    let items = ref([]);
    //update and create jsonrequest

    const Subgroupform: any = ref({
      Id: 0,
      Name: "",
      Code: "",
      Description: "",
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
      AccheadId: 0,
      NatureofGroupName: 0,
      ClassificationType: 0,
      Level: 0,
      ParentId: 0,
      ReportSequence: 0,
      BalanceSheetNotes: "",
      OrganizationId: 0,
      IsSystemDefined: false,
    });

    async function IsEdit() {
      showDialog.value = true;
      emit("loadershow");
      try {
        label.value = "Update";
        let Id = model.value.Id;
        const response = await AccountSubHeadService.getfindonedata(
          Id,
          HospitalId
        );
        let data = response["result"];
        Object.keys(Subgroupform.value).forEach((key) => {
          if (data[key]) Subgroupform.value[key] = data[key];
        });
        await handleAccSubChange();
        Subgroupform.value.ClassificationType = Number(
          Subgroupform.value.ClassificationType
        );

        Editmodel.value = false;
        showDialog.value = false;
        emit("loaderhide");
        showDialog.value = true;
      } catch (error) {
        showDialog.value = false;
        emit("loaderhide");
        alert(error);
      }
    }
    //Submit Function
    const IsSubmit = async () => {
      emit("loadershow");
      Saveloading.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        Subgroupform.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        Subgroupform.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        Subgroupform.value.BranchId = BranchId;
        Subgroupform.value.HospitalId = HospitalId;
        Subgroupform.value.ModifiedBy = UserId;
        Subgroupform.value.CreatedBy = UserId;
        Subgroupform.value.EntityId = Number(Entitydata.value.EntityId);
        Subgroupform.value.ClassificationType =
          Subgroupform.value.ClassificationType.toString();
        Subgroupform.value.NatureofGroupName =
          Subgroupform.value.NatureofGroupName.toString();
        Subgroupform.value.OrganizationId = HospitalId;

        if (Subgroupform.value.Id != 0) {
          Subgroupform.value.EntityOperationId = props.OperationID.UpdateId;
          const response = await AccountSubHeadService.updatedata(
            Subgroupform.value
          );
          let message = response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (response["result"] == "Already" && message == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            Saveloading.value = false;
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          Subgroupform.value.EntityOperationId = props.OperationID.CreateId;
          const response = await AccountSubHeadService.createdata(
            Subgroupform.value
          );
          console.log(Subgroupform.value);
          let message = response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (response["result"] == "Already" && message == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            Saveloading.value = false;
            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        Saveloading.value = false;
        emit("loaderhide");
        alert(error);
      }
    };
    const copydataModel = JSON.parse(JSON.stringify(Subgroupform.value));
    const copyselectOption = JSON.parse(JSON.stringify(items.value));

    const IsClear = () => {
      Object.assign(Subgroupform.value, copydataModel);
      Object.assign(items.value, copyselectOption);
      emit("update:selectedItem", undefined);
      emit("close");
      console.log(Subgroupform.value);
    };

    //Get Code
    async function GetCode() {
      debugger;
      let data = {
        //FormId: 24,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
        Iscommon: 1,
        RoleId: rolesData.RoleId || 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      Subgroupform.value.Code = result;
      if (result) {
        showDialog.value = true;
      }
    }
    async function IsEditpop() {
      Editmodel.value = true;
    }
    //Created Sucessfully Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      emit("load");
      IsClear();
    }
    const alreadyexistpop = ref(false);
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      Subgroupform.value.Name = ""; //showDialog.value = true
    }

    async function LoadAccountHeadList() {
      debugger;
      try {
        const response = await AccountHeadService.getHeadsByOrganizationId(
          HospitalId
        );
        AccHeadOptions.value = response["result"].map((item: any) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    }
    async function LoadNatureList() {
      try {
        const response = await AccountHeadService.getNatureOfGroupList();

        natureOptions.value = response["result"].map((item: any) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    }

    const handleAccSubChange = async () => {
      debugger;
      debugger;

      try {
        if (Subgroupform.value.AccheadId != null) {
          let selectedGroup = AccHeadOptions.value.find(
            (g: any) => g.Id === Subgroupform.value.AccheadId
          );
          Subgroupform.value.NatureofGroupName = Number(
            selectedGroup?.NatureId
          );
        }
      } catch (error) {
        console.error("Error fetching parent group details:", error);
      }
    };
    return {
      model,
      alreadyclosetrigger,
      alreadyexistpop,
      IsEditpop,
      closetrigger,
      Editmodel,
      updatepop,
      successpop,
      IsCreate,
      showDialog,
      IsClear,
      IsEdit,
      Subgroupform,
      IsSubmit,
      GetCode,
      label,
      Saveloading,
      AccHeadOptions,
      LoadAccountHeadList,
      LoadNatureList,
      handleAccSubChange,
      natureOptions,
      ClassificationOptions,
    };
  },
  created() {},
});
</script>
